<template>
	<div class="index">
		
		<van-sticky>
		  <van-search
		  @click="goSearch"
			readonly
		    shape="round"
		    background="#42C052"
		    :placeholder="group_search"
		  />
		</van-sticky>
		<div style="position: relative;width: 100%;padding-top: 66%; ">
			<van-image
			  width="100%"
			  height="100%"
			  fit="cover"
			  position="center"
			  :src="bgImg"
			  lazy-load
			  :show-loading='true'
			  style="vertical-align: middle; position: absolute;left: 0; top: 0; ">
				<template v-slot:loading>
					<van-loading type="spinner" size="20"/>
				</template>
			</van-image>
		</div>		
	<!-- 	<van-tabs v-model="activeName" background="#42C052" color="#fff" title-active-color="#fff" title-inactive-color="#fff"  @click="goActivityList" sticky class="tab-box">
		  <van-tab title="" name="nowActivity" style="padding-top: 10px;" title-style="font-size:20px"> -->
			  <div class="ac-box"   v-for="(item,index) in activityData.data" :key="index + '-only'" @click="goActivity(item.id)">
			  	<div style="background-color: #fff;padding: 10px 0;border-radius: 10px 10px 0 0;">
			  		<!-- <img :src="require('../../assets/acbg.jpg')" class="ac-box-img" style="border: 2px solid #fff;"> -->
					<!-- <div class="ac-box-title van-multi-ellipsis--l2">{{item.category_name}}</div> -->
					<van-row type="flex" justify="space-around" gutter="0">
					  <van-col span="5" class="f-mc" >
						  <van-image
						    width="100%"
						    height="auto"
						    :src='require("../../assets/left-line.png") ' 
						  />
					  </van-col>
					  <van-col span="12" style="display: flex;height: 100%;align-items: center;justify-content: center;">
						  <van-image
						    width="30"
							fit="contain"
						    :src='require("../../assets/fire.png") ' 
						  />
						  <span class="ac-box-tag" style="margin-left: 10px;">{{item.category_name}}</span>
					  </van-col>
					   <van-col span="5" class="f-mc">
						   <van-image
						     width="100%"
						     height="auto"
						     :src='require("../../assets/right-line.png") ' 
						   />
					   </van-col>
					</van-row>
					
			  		<van-row  type="flex" justify="space-around" style=" padding: 15px 2%;">
			  		  <van-col span="5" style=" border: 1px solid #ff7200; background-color: #fff;border-radius: 4px;padding: 4px 0; box-sizing: border-box;" v-for="(i,index) in item.activity_item" :key="index + '-only'">
			  			  <van-image
			  			  
						  width="50px"
						  height="50px"
			  			  radius='10'	  
			  			   fit="contain"
			  			    :src="i.image"
							style="overflow: hidden;"
			  			  />
			  			  <div style="" class="ac-product">{{i.name}}</div>
			  			  <div style="color: red;" class="ac-product">¥{{i.vip_price}}</div>
			  		  </van-col>		  						  
			  		</van-row>
			  	</div>
			  	<div style=" background-color: #ff7200;display: flex;flex-direction: column;justify-content: space-around; border-radius: 0 0 8px 8px; padding: 5px 10px; width: 100%;box-sizing: border-box;">
			  		<van-row type="flex" style="align-items:center;">
			  		  <van-col span="24" style="flex: 1;text-align: left;">					  
							<van-count-down  :time="(item.end_time-item.current_time)*1000" format="DD天HH时mm分ss秒" style="display:inline-block;color: #fff;letter-spacing:1px;font-size: 15px;" />
			  				<span style=" color: #fff; font-size: 16px;"> 后结束</span>		 
			  		  </van-col>

			  		</van-row>
			  		<van-row type="flex" style="justify-content: space-between;align-items:center;">
			  		  <van-col span="14" style="color: #fff; font-size: 10px; flex: 1;text-align: left;">
			  			  <span>￥</span><span style="font-size: 24px;font-weight: 550; ">{{item.min_price}}</span><span>起 </span>
			  						  <!-- <span style="font-size: 14px; color:#ccc;margin-left: 5px;"> 已团1000件</span> -->
			  		  </van-col>
			  		  <van-col span="10" style="text-align: right;">
						  <button style="width: 100px;height: 24px; line-height: 24px; font-size: 16px;background-color: #fff;border: none; border-radius: 12px;color: #ff7200; " >查看全部</button>
			  		  </van-col>
			  		</van-row>			
			  	</div>			
			  </div>
			  <!-- <van-divider :style="{ color: '#fff', borderColor: '#fff', padding: '0 16px' }"> 没有更多了</van-divider> -->
	<!-- 	  </van-tab> -->
		  <!-- 即将开团 -->
		  <!-- <van-tab title="即将开团" name="nextActivity" style=" padding-top: 10px" title-style="font-size:20px">
				<div class="ac-box"   v-for="(item,index) in activityData.data" :key="index + '-only'" @click="goActivity(item.id)">
					<div style="position: relative;">
						<img :src="require('../../assets/ac1.jpg')" class="ac-box-img">
						<div class="ac-box-title van-multi-ellipsis--l2">{{item.title}}</div>
						<van-row  type="flex" justify="space-around" style="position: absolute;top: 80px; padding: 0 2%;">
						  <van-col span="5" style="background-color: #fff;border-radius: 4px;padding: 4px 0; box-sizing: border-box;" v-for="(i,index) in item.activity_item" :key="index + '-only'">
							  <van-image
							  width="60%"
							  radius='10'	  
							   fit="contain"
							    :src="i.image"
							  />
							  <div style="" class="ac-product">{{i.name}}</div>
							  <div style="color: red;" class="ac-product">¥{{i.vip_price}}</div>
						  </van-col>		  						  
						</van-row>
					</div>
					<div style=" background-color: #FFF;display: flex;flex-direction: column;justify-content: space-around; border-radius: 0 0 8px 8px; padding: 10px 4%;">
						<van-row type="flex" style="align-items:center;">
						  <van-col span="24" style="flex: 1;text-align: left;">					  
								 <van-count-down  :time="(item.start_time-item.current_time)*1000" format="DD天HH时mm分ss秒" style="display:inline-block;color: red;letter-spacing:1px;" />
								 <span style=" color: red; font-size: 14px;"> 后开始</span>		
						  </van-col>
				
						</van-row>
						<van-row type="flex" style="justify-content: space-between;align-items:center;">
						  <van-col span="14" style="color: red; font-size: 10px; flex: 1;text-align: left;">
							  <span>￥</span><span style="font-size: 24px; font-weight: 550;">{{item.min_price}}</span><span>起 </span>
						  </van-col>
						  <van-col span="10" style="text-align: right;">
								<button style="width: 100px;height: 24px; line-height: 24px; font-size: 14px;background-color: #ee0a24;border: none; border-radius: 12px;color: #fff;" >即将开团</button>
						  </van-col>
						</van-row>			
					</div>			
				</div>
				<div v-if="!activityData.data" style="color: #fff;">没有即将开团的活动!</div>						
		  </van-tab> -->
	<!-- 	</van-tabs>	 -->
			
<!-- 活动区 -->
		<van-tabbar route placeholder safe-area-inset-bottom active-color="#42C052">
		   <van-tabbar-item replace to='/activityList' icon="home-o">首页</van-tabbar-item>
		   <van-tabbar-item replace to="/cart" icon="cart-o" :badge="this.$store.state.cartTotalNum>0 ? this.$store.state.cartTotalNum :''">购物车</van-tabbar-item>
		   <van-tabbar-item replace to="/userCenter" icon="user-o">我的</van-tabbar-item>
		 </van-tabbar>
	</div>
</template>

<script>
	import {mapState,mapActions} from 'vuex'
	export default{
		name:"activityList",
		data(){
			return{
				activeName:'nowActivity',
				activityData:{},//活动列表数据
				bgimg:'',
			}
		},
		methods:{
			...mapActions(['getbaseConfig',]),
			// 点击切换
			goActivityList(name){				
				if(name=='nextActivity'){
					this.getActivityList(2)
				}
				else{
					this.getActivityList(1)
				}
			},
			//获取团购活动列表
			getActivityList(type){
				this.request.postURL('/api/activity/getActivityList',{
					page:1,
					pageSize:50,
					type:type
				}).then((res)=>{	
					this.activityData=res.data.data;
					this.$wxShare(0)
				}).catch( (err) =>{
				   console.log(err)
				  });
			},
			//进入活动详情
			 goActivity(id){
				this.$router.push({
					path:'/activityInfo',
					query:{
						id:id
					}
				})
			},	
			//获取首页背景图
			getBgImg(){
				this.request.postURL('/api/activity/getBgImg',{
				}).then((res)=>{	
					this.bgimg=res.data.data.bg_img
				}).catch( (err) =>{
				   console.log(err)
				  });
			},
			goSearch(){
				// console.log(this.$router)
				this.$router.options.routes[15].meta.keepAlive = false
				// console.log(this.$router)
				this.$router.push({
					path:'/searchList',
				})
			}
		},
		computed:{
			 ...mapState(['bgImg','group_search',]),
		},
		created() {
			//this.getBgImg()
			this.getbaseConfig()
			this.getActivityList(1)
			
		},
	}
</script>

<style scoped>
	.index{
		background-color: #42C052 ;
		padding-bottom: 50px;
		min-height:100vh;
		box-sizing: border-box;
	}
	.small-tag{
		font-size: 12px;
		font-weight: 550;
		display: inline-block;
		background-color: #fff;
		color: #FE5504; 
		width: 12px; 
		height: 18px;
		line-height: 18px;
		border-radius: 2px;
		margin-right: 2px;
	}
	.data-title{
		text-align: center;
		color:#FDEF4E ; 
		font-size: 14px;
		font-weight: 500; 
		margin-top: 20px;
	}
	.data-box{
		display: flex;
		justify-content: center;
		font-size: 10px;
		color: #fff;
		margin-top: 10px;
	}
	.data-info{
		display: flex;
		flex-direction: column;
		width: 94%; 
		height: 40px;
		background-color: #54a948; 
		border-radius: 10px; 
		display: flex;
		justify-content: center;
		align-items: center;
		/* letter-spacing:-1px; */
		font-size: 14px;
		font-weight: 550;
		padding:10px 0;
	}
	.ac-box{
		width: 100%;
		padding: 0 3% 0 3%;  
		display: flex;
		flex-direction: column;
		margin-bottom: 15px;
		box-sizing: border-box;
	}
	.ac-box-img{
		max-width: 100%;
		object-fit:cover; 
		border-radius: 8px 8px 0 0;
		vertical-align:middle;
		background-color: #fff;
		/* background-color: #1ba22c;
		border: 2px solid #fff; */
		
	}
	.ac-box-tag{
		font-size: 20px;;
		color:#ff7200 ;
		font-weight: 700;
		text-align: left;
	}
	.ac-box-title{
		/* color: #fff; */
		color:#fffc00 ;
		font-size: 20px;
		font-size: 24px;
		font-weight: 550;  
		
		/* text-align: left; */
		text-align: center;
		position: absolute;
		top: 10px;
		width: 100%;
		padding: 0 2%;
		padding-left: 32px;
		box-sizing: border-box;
			
	}
	.ac-box-info{
		font-size: 16px;
		color: rgba(255,255,255,0.9);
		text-align: left;
		position: absolute;
		top: 56px;
		padding: 0 4%;	
	}
	.ac-product{
		font-size: 12px; 
		line-height: 16px;
		text-align: center;
		padding: 0 1%;
		white-space:nowrap; 
		overflow:hidden; 
		text-overflow:ellipsis;
	}
	.f-mc{
		display: flex;
		align-items: center;
	}


</style>
